import React from "react";

const StripSection = () => {
  return (
    <div className="strip-section section">
      <div className="container">
        <div className="headd">
          <h2>Key Features</h2>
        </div>
        <ul className="strip_section-row">
          <li>
            <div className="strip-box">
              <div className="title">2 & 3 BHK</div>
              <div className="sub_title">Configuration</div>
            </div>
          </li>
          <li>
            <div className="strip-box">
              <div className="title">On Request</div>
              <div className="sub_title">Land Parcel</div>
            </div>
          </li>
          <li>
            <div className="strip-box">
              <div className="title">Coming Soon</div>
              <div className="sub_title">Project Status</div>
            </div>
          </li>
          <li>
            <div className="strip-box">
              <div className="title">Sion</div>
              <div className="sub_title">Location</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default StripSection;
